"use client";

import { useMarket } from "@features/market/useMarket";
import { useMemo } from "react";

import type { StockProps } from "./Stock.types";
import { getStockStatus } from "./Stock.utils";

export function useStockStatus({ item, type }: StockProps) {
  const market = useMarket();

  const status = useMemo(() => {
    if (!item) return;
    if (type === "pdp") {
      return getStockStatus({
        type,
        item,
        locale: market.locale,
      });
    }
    if (type === "plp") {
      return getStockStatus({
        type,
        item,
        locale: market.locale,
      });
    }
    if (type === "cart" || type === "checkout") {
      return getStockStatus({
        type,
        item,
        locale: market.locale,
      });
    }
    return;
  }, [item, type, market]);

  return status;
}
